import { render, staticRenderFns } from "./MenuFilterSelect.vue?vue&type=template&id=2a3e78d7"
import script from "./MenuFilterSelect.vue?vue&type=script&lang=js"
export * from "./MenuFilterSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports